import { LinkedIn } from "@/components/icons/linkedin";
import { Instagram } from "@/components/icons/instagram";
import { Twitter } from "@/components/icons/twitter";
import { Facebook } from "@/components/icons/facebook";
import { NavMenuItem } from "./header";

export const footerLinks = [
  { title: "terms", href: "/legal/terms" },
  { title: "privacy", href: "/legal/privacy" },
  { title: "cookies", href: "/cookies" },
];

export const socials = [
  {
    platform: "linkedIn",
    icon: LinkedIn,
    link: "https://www.linkedin.com/showcase/proc360bycheckit",
  },
  {
    platform: "instagram",
    icon: Instagram,
    link: "https://www.instagram.com/proc360bycheckit",
  },
  {
    platform: "facebook",
    icon: Facebook,
    link: "https://www.facebook.com/share/172zRDwfrJ",
  },
  {
    platform: "x",
    icon: Twitter,
    link: "https://x.com/Proc360Care",
  },
];

export const menuItems: NavMenuItem[] = [
  {
    title: "product",
    children: [
      {
        title: "finance",
        href: "/products/finance",
      },
      {
        title: "Buy For Me",
        href: "/products/buy-for-me",
      },
      {
        title: "Pack n Check",
        href: "/products/pack-n-check",
      },

      {
        title: "logistics",
        href: "/products/logistics",
      },
      {
        title: "marketplace",
        href: "#",
      },
    ],
  },
  {
    title: "solutions",
    children: [
      {
        title: "expertise",
        href: "/solutions/expertise",
      },
      {
        title: "industry",
        href: "/solutions/industry",
      },
      {
        title: "product category",
        href: "/solutions/product-category",
      },
    ],
  },
  {
    title: "resources",
    children: [
      {
        title: "blogs",
        href: "/blog",
      },
      {
        title: "events",
        href: "/events",
      },
      {
        title: "library",
        href: "/library",
      },
      {
        title: "shipment tracker",
        href: "/tracker",
      },
      {
        title: "shipment calculator",
        href: "/shipment-calculator",
      },

      {
        title: "guides",
        href: "#",
      },
      {
        title: "currency converter",
        href: "#",
      },
    ],
  },
  {
    title: "Help center",
    children: [
      {
        title: "FAQs",
        href: "/faqs",
      },
      {
        title: "contact us",
        href: "/finance",
      },
    ],
  },
  {
    title: "community",
    href: "/community",
  },
  {
    title: "pricing",
    href: "/pricing",
  },
];
